import React, { useEffect, useState } from 'react';
import '../estimation/estimateInvoice.scss';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import CurrencyValue from 'ui-component/CurrencyValue';
import CurrencyValueFlex from 'ui-component/CurrencyValueFlex';
import { Skeleton } from '@mui/material';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import StatusBadge from 'ui-component/StatusBadge';
import { MdOutlineStickyNote2 } from 'react-icons/md';
import ProductCommentModal from '../estimation/modals/ProductCommentModal';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { EditIcon, NoPhoneIcon } from 'ui-component/custom-icons/icons';

// ✅ Clear
function SalesOrderDetailInvoice({ salesOrder, isPageLoading, viewedBy = 'ADMIN' }) {
	const [settingsDetails, setSettingsDetails] = useState();
	const [productComment, setProductComment] = useState('');
	const [productName, setProductName] = useState('');
	const [productImage, setProductImage] = useState('');
    const [isInternalLoading, setIsInternalLoading] = useState(true);
	const history = useNavigate();
	const [isLoading, setIsLoading] = useState(true);

	const totalQty = salesOrder?.sales_order_items?.reduce((total, detail) => total + (detail?.qty || 0), 0);

	const handleCommentModal = (product, image, comment) => {
		setProductComment(comment);
		setProductName(product);
		setProductImage(image);
	}
	const handleCloseComment = () => {
		setProductComment('');
		setProductName('');
		setProductImage('');
	}

	if (viewedBy === 'ADMIN') {

		const getCookie = (name) => {
			const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			if (match) return JSON.parse(decodeURIComponent(match[2]));
			return null;
		};
		const setCookie = (name, value, days = 7) => {
			const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
			document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; expires=${expires}; path=/`;
		};
		useEffect(() => {
			const cookieSettings = getCookie('invoiceSettingsDetails');	
			if (cookieSettings) {
				setSettingsDetails(cookieSettings);
				setIsInternalLoading(false);
				return;
			}
			api.getSettings().then((res) => {
				setSettingsDetails(res?.data);
				setCookie('invoiceSettingsDetails', res?.data);
				setIsInternalLoading(false);
			});
		}, []);
	} else {

    	const getCookie = (name) => {
			const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			if (match && match[2] && match[2] !== "undefined") {
				try {
					return JSON.parse(decodeURIComponent(match[2]));
				} catch (e) {
					return null;
				}
			}
			return null;
		};
		const setCookie = (name, value, days = 7) => {
			const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
			document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; expires=${expires}; path=/`;
		};
		useEffect(() => {
			const cookieSettings = getCookie('invoiceSettingsDetails');	
			if (cookieSettings) {
				setSettingsDetails(cookieSettings);
				setIsInternalLoading(false);
				return;
			}
			api.getClientSettings().then((res) => {
				setSettingsDetails(res?.data);
				setCookie('invoiceSettingsDetails', res?.data);
				setIsInternalLoading(false);
			});
		}, []);
	}

	useEffect(() => {
		setIsLoading(isPageLoading);
	}, [isPageLoading])
	return (
		<>
			<div className="est-inv-container" style={{ padding: '15px', position: 'relative' }}>
				<div
					style={{
						position: 'absolute',
						right: '0',
						top: '0',
						zIndex: '10'
					}}
				>

					{
						viewedBy === 'ADMIN' && (
							salesOrder && (
								salesOrder?.master_status?.name !== 'Completed' && (
									<PermissionAllowed permissions={['Edit Sales Order']}>
										<button
											type="button"
											className="btn btn-primary btn-outlined-main white-var"
											disabled={isInternalLoading || !salesOrder?.sales_order_number}
											onClick={() => {
												history(`/sales/sales-orders/edit/${salesOrder?.id}`);
											}}
										>
											<EditIcon height="17px" width="17px" />
											Edit
										</button>
									</PermissionAllowed>
								)
							)
						)
					}
				</div>
				
				<div className="row m-0">
					{salesOrder ? (
						<>
							<div className="col-12">
								<div className="row orf-head">
									<div className="col-12 col-md-8 p-0 d-flex align-items-center company-logo">
										{isLoading ? (
											<div style={{ width: '200px' }}>
												<Skeleton variant="rounded" width={'100%'} height={40}></Skeleton>
											</div>
										) : (
											settingsDetails?.logo_url ? (
												<div className="est-detail-logo" style={{ height: '36px' }}>
													<img src={settingsDetails?.logo_url} height={'36px'} />
												</div>
											) : (
												<div className="est-detail-logo" style={{ height: '36px' }}>
													<h3>{settingsDetails?.client_full_name}</h3>
												</div>
											)
										)}
									</div>
									<div className="col-12 col-md-4 p-0">
										<div className="company-details" style={{ marginTop: '10px' }}>
											{isLoading ? (
												<p className="m-0">
													<div style={{ width: '200px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
													<div style={{ width: '200px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
													<div style={{ width: '200px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
													<div style={{ width: '200px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
													<div style={{ width: '200px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
												</p>
											) : (
												settingsDetails?.client_code && (
													<p className="m-0">
														<b> {settingsDetails?.client_full_name}</b> <br />
														{settingsDetails?.invoice_details1 && (
															<>{settingsDetails?.invoice_details1} <br /></>
														)}
														{settingsDetails?.invoice_details2 && (
															<>{settingsDetails?.invoice_details2} <br /></>
														)}
														{settingsDetails?.invoice_details3 && (
															<>{settingsDetails?.invoice_details3} <br /></>
														)}
														{settingsDetails?.invoice_details4 && (
															<>{settingsDetails?.invoice_details4} <br /></>
														)}
														{settingsDetails?.invoice_details5 && <>{settingsDetails?.invoice_details5}</>}
													</p>
												)
											)}
										</div>
									</div>
								</div>
							</div>
							<div className="col-12 mobile-no-pad" style={{ marginTop: '20px' }}>
								<div className="row orf-head hide-on-mobile">
									<div className="col-12 col-md-8 p-0 d-flex align-items-center company-logo">
										{isLoading ? (
											<p className="m-0">
												<div style={{ width: '100px', marginBottom: '12px' }}>
													<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
												</div>
												<b>
													<div style={{ width: '150px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
												</b>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</p>
										) : (
											<p className="m-0">
												<div style={{ width: '80px', marginBottom: '10px' }}>
													<StatusBadge itemStatus={'Customer'} />
												</div>
												<b>
													<PrivacyModeContent>{salesOrder?.customer?.name}</PrivacyModeContent>
												</b>{' '}
												<br />
												<PrivacyModeContent>{salesOrder?.customer?.address}</PrivacyModeContent> <br />
												<PrivacyModeContent>
													{(salesOrder?.customer?.city == 'null' ? salesOrder?.customer?.city + ', ' : '') +
														salesOrder?.customer?.zipcode}
												</PrivacyModeContent>{' '}
												<br />
												<PrivacyModeContent>{salesOrder?.customer?.country}</PrivacyModeContent>
											</p>
										)}
									</div>
									<div className="col-12 col-md-4 p-0">
										<div className="company-details">
											{isLoading ? (
												<p className="m-0">
													<div style={{ width: '100px', marginBottom: '12px' }}>
														<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
													</div>
													<b>
														<div style={{ width: '150px', marginBottom: '5px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
														</div>
													</b>
													<div style={{ width: '150px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
													<div style={{ width: '150px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
													<div style={{ width: '150px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
												</p>
											) : (
												salesOrder?.transit_company?.name && (
													<p className="m-0">
														<div style={{ width: '130px', marginBottom: '10px' }}>
															<StatusBadge itemStatus={'Transit Company'} />
														</div>
														<b>
															<PrivacyModeContent>{salesOrder?.transit_company?.name}</PrivacyModeContent>
														</b>{' '}
														<br />
														<PrivacyModeContent>{salesOrder?.transit_company?.address}</PrivacyModeContent> <br />
														<PrivacyModeContent>
															{(salesOrder?.transit_company?.city == 'null' ? salesOrder?.transit_company?.city + ', ' : '') +
																salesOrder?.transit_company?.zipcode}
														</PrivacyModeContent>{' '}
														<br />
														<PrivacyModeContent>{salesOrder?.transit_company?.country}</PrivacyModeContent>
													</p>
												)
											)}
										</div>
									</div>
								</div>
								<div className="new-customer-detail-container show-on-mobile">
									<div className="" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
										<div className="new-customer-detail-badge">Customer</div>
										<div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0.4em', paddingRight: '0.4em' }}>
											<b>
												<PrivacyModeContent>{salesOrder?.customer?.name}</PrivacyModeContent>
											</b>{' '}
											<PrivacyModeContent>{salesOrder?.customer?.address}</PrivacyModeContent>
											<PrivacyModeContent>
												{(salesOrder?.customer?.city == 'null' ? salesOrder?.customer?.city + ', ' : '') + salesOrder?.customer?.zipcode}
											</PrivacyModeContent>{' '}
											<PrivacyModeContent>{salesOrder?.customer?.country}</PrivacyModeContent>
										</div>
									</div>
									{salesOrder?.transit_company?.name && (
										<div className="" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
											<div className="new-customer-detail-badge">Transit Company</div>
											<div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0.4em', paddingRight: '0.4em' }}>
												<b>
													<PrivacyModeContent>{salesOrder?.transit_company?.name}</PrivacyModeContent>
												</b>{' '}
												<PrivacyModeContent>{salesOrder?.transit_company?.address}</PrivacyModeContent>
												<PrivacyModeContent>
													{(salesOrder?.transit_company?.city == 'null' ? salesOrder?.transit_company?.city + ', ' : '') +
														salesOrder?.transit_company?.zipcode}
												</PrivacyModeContent>{' '}
												<PrivacyModeContent>{salesOrder?.transit_company?.country}</PrivacyModeContent>
											</div>
										</div>
									)}
								</div>
							</div>
						</>
					) : (
						<>
							<div className="col-12">
								<div className="row orf-head">
									<div className="col-12 col-md-8 p-0 d-flex align-items-center company-logo">
										<div style={{ width: '200px' }}>
											<Skeleton variant="rounded" width={'100%'} height={40}></Skeleton>
										</div>
									</div>
									<div className="col-12 col-md-4 p-0">
										<div
											style={{
												position: 'absolute',
												right: '0',
												top: '0'
											}}
										>
											<div style={{ width: '100px', minWidth: 'unset', position: 'absolute', right: '-15px', top: '-20px' }}>
												<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
											</div>
										</div>
										<div className="company-details" style={{ marginTop: '10px' }}>
											<p className="m-0">
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-12" style={{ marginTop: '35px' }}>
								<div className="row orf-head">
									<div className="col-12 col-md-8 p-0 d-flex align-items-center company-logo">
										<p className="m-0">
											<div style={{ width: '100px', marginBottom: '12px' }}>
												<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
											</div>
											<b>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</b>
											<div style={{ width: '150px', marginBottom: '5px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
											<div style={{ width: '150px', marginBottom: '5px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
											<div style={{ width: '150px', marginBottom: '5px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</p>
									</div>
									<div className="col-12 col-md-4 p-0">
										<div className="company-details">
											<p className="m-0">
												<div style={{ width: '100px', marginBottom: '12px' }}>
													<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
												</div>
												<b>
													<div style={{ width: '150px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
												</b>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</p>
										</div>
									</div>
								</div>
							</div>
						</>
					)}
				</div>

				<div className="row mx-0 hide-on-mobile" style={{ marginTop: '20px', alignItems: 'center' }}>
					<div className="col-6 col-md-8 p-0">
						{!salesOrder ? (
							<div style={{ width: '150px', marginBottom: '5px' }}>
								<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
							</div>
						) : (
							<h3 className="est-ref m-0">
								{salesOrder?.master_status?.name == 'Draft' ? (
									<span style={{ fontStyle: 'italic', color: '#929598', fontSize: '20px', fontWeight: '400' }}>
										Sales Order {salesOrder?.sales_order_number}
									</span>
								) : (
									`Sales Order ${salesOrder?.sales_order_number}`
								)}
							</h3>
						)}
					</div>
					<div className="col-6 col-md-4 p-0">
						<table className="w-100">
							<tr>
								<td>
									{!salesOrder ? (
										<div style={{ width: '110px', marginBottom: '8px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
										</div>
									) : (
										'Date Ordered:'
									)}
								</td>
								<td className="text-right">
									{!salesOrder ? (
										<div className="w-full flex justify-content-end">
											<div style={{ width: '110px', marginBottom: '8px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									) : (
										moment(salesOrder?.start_at).format(CommonDateOnlyFormat)
									)}
								</td>
							</tr>
							<tr>
								<td>
									{!salesOrder ? (
										<div style={{ width: '110px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
										</div>
									) : (
										'Due Date:'
									)}
								</td>
								<td className="text-right">
									{!salesOrder ? (
										<div className="w-full flex justify-content-end">
											<div style={{ width: '110px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									) : (
										moment(salesOrder?.expires_at).format(CommonDateOnlyFormat)
									)}
								</td>
							</tr>
						</table>
					</div>
				</div>

				<div className="estimation-title show-on-mobile">
					{!salesOrder ? (
						<div style={{ width: '150px', marginBottom: '5px' }}>
							<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
						</div>
					) : (
						<h3 className="est-ref m-0">
							{salesOrder?.master_status?.name == 'Draft' ? (
								<span style={{ fontStyle: 'italic', color: '#929598', fontSize: '20px', fontWeight: '400' }}>
									{' '}
									{salesOrder?.sales_order_number}
								</span>
							) : (
								`Sales Order ${salesOrder?.sales_order_number}`
							)}
						</h3>
					)}
					{salesOrder ? (
						salesOrder?.transaction_type == 'Invoice' ? (
							<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
								<div>Date:</div>
								<div style={{ textAlign: 'right' }}>
									{salesOrder?.master_status?.name == 'Credit Note'
										? moment(salesOrder?.start_date).format(CommonDateOnlyFormat)
										: moment(salesOrder?.invoice_date).format(CommonDateOnlyFormat)}
								</div>
							</div>
						) : (
							<>
								<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
									<div>Date Ordered:</div>
									<div style={{ textAlign: 'right' }}>{moment(salesOrder?.start_date).format(CommonDateOnlyFormat)}</div>
								</div>
								<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
									<div>Due Date:</div>
									<div style={{ textAlign: 'right' }}>{moment(salesOrder?.expires_at).format(CommonDateOnlyFormat)}</div>
								</div>
							</>
						)
					) : (
						<>
							<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
								<div>
									<div style={{ width: '110px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
								<div>
									<div style={{ width: '110px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
							</div>
							<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
								<div>
									<div style={{ width: '110px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
								<div>
									<div style={{ width: '110px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
							</div>
						</>
					)}
				</div>

				<div className="est-inv-items hide-on-mobile" style={{ marginTop: '20px' }}>
					<table className="w-100">
						<thead>
							<tr>
								<th colSpan={2}>
									{!salesOrder ? (
										<div style={{ width: '110px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										'Model'
									)}
								</th>
								<th className="hide-on-mobile text-center">
									{!salesOrder ? (
										<div style={{ width: '90px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										'Comment'
									)}
								</th>
								<th className="text-center">
									{!salesOrder ? (
										<div className="flex justify-content-center w-full">
											<div style={{ width: '50px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
											</div>
										</div>
									) : (
										'Quantity'
									)}
								</th>
								{
									viewedBy === 'ADMIN' && (
										<>
											<th className="text-right">
												{!salesOrder ? (
													<div className="w-full flex justify-content-end">
														<div style={{ width: '60px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
														</div>
													</div>
												) : (
													'Price'
												)}
											</th>
											<th className="text-right">
												{!salesOrder ? (
													<div className="w-full flex justify-content-end">
														<div style={{ width: '60px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
														</div>
													</div>
												) : (
													'Total'
												)}
											</th>
										</>
									)
								}
							</tr>
						</thead>
						<tbody>
							{!salesOrder ? (
								[...Array(10)].map((e, i) => (
									<tr>
										<td className="hide-on-mobile">
											<div style={{ width: '23px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
											</div>
										</td>
										<td>
											<div style={{ width: '180px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
											</div>
										</td>
										<td className="text-center">
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
											</div>
										</td>
										<td className="text-center">
											<div className="flex justify-content-center w-full">
												<div style={{ width: '50px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											</div>
										</td>
										{
											viewedBy === 'ADMIN' && (
												<>
													<td className="text-right d-none d-md-block">
														<div className="flex justify-content-end w-full">
															<div style={{ width: '80px' }}>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
															</div>
														</div>
													</td>
													<td className="text-right">
														<div className="flex justify-content-end w-full">
															<div style={{ width: '80px' }}>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
															</div>
														</div>
													</td>
												</>
											)
										}
									</tr>
								))
							) : (
								salesOrder?.sales_order_items?.map((item) => (
									<tr>
										<td className="hide-on-mobile">
											{item?.product?.thumbnail_url ? (
												<img src={item?.product?.thumbnail_url} style={{ width: '23px', height: '35px' }} alt="product" />
											) : item?.product?.custom_thumbnail_url ? (
												<img src={item?.product?.custom_thumbnail_url} style={{ width: '23px', height: '35px' }} alt="product" />
											) : (
												<NoPhoneIcon width={'23px'} height={'32px'} />
											)}
										</td>
										<td>
											<p className="p-0 m-0">
												<a href={`/products/${item?.product?.id}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
													{item?.product?.product_name} {item?.selectedColorName && ` ${item?.selectedColorName}`}
												</a>
											</p>
											{item?.comment ? <p className="hide-on-non-mobile mobile-prod-comment-ui">{item?.comment}</p> : ''}
										</td>
										{salesOrder?.master_status?.name != 'Credit Note' && (
											<td style={{ maxWidth: '80px' }} className="hide-on-mobile text-center">
												<div
													style={{ cursor: 'pointer' }}
													onClick={() => {
														handleCommentModal(item?.product?.product_name, item?.product?.thumbnail_url, item?.comment);
													}}
												>
													{item?.comment ? (
														<MdOutlineStickyNote2 size={18} />
													) : (
														'---'
													)}
												</div>
											</td>
										)}
										<td className="text-center">{item?.qty}</td>
										{
											viewedBy === 'ADMIN' && (
												<>

													<td className="text-right d-none d-md-table-cell">
														<CurrencyValueFlex currencyObject={item?.converted_currency_unit_price} defaultCurrency={salesOrder?.currency} flex={true} />
													</td>
													<td className="text-right">
														<CurrencyValueFlex currencyObject={item?.converted_currency_total_price} defaultCurrency={salesOrder?.currency} flex={true} />
													</td>
												</>
											)
										}
									</tr>
								))
							)}

							<tr style={{ height: '10px' }}>
								<td></td>
							</tr>
							{salesOrder?.shipping_fee > 0 && (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile text-center"></td>
									<td className="d-md-none"></td>
									<td className="text-right">Shipping</td>
									<td className="text-right">
										<CurrencyValueFlex currencyObject={salesOrder?.converted_currency_shipping_fee} defaultCurrency={salesOrder?.currency} flex={true} />
									</td>
								</tr>
							)}

							{salesOrder?.total_discount > 0 && (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="d-md-none"></td>
									<td className="text-right">Discount {salesOrder?.discount_type == 'percentage' ? `(${salesOrder?.discount}%)` : ''}</td>
									<td className="text-right">
										<CurrencyValueFlex currencyObject={salesOrder?.converted_total_discount} defaultCurrency={salesOrder?.currency} flex={true} />
									</td>
								</tr>
							)}

							{salesOrder?.vat_type == 'Excluding VAT' && (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="d-md-none"></td>
									<td className="text-right">VAT ({salesOrder?.vat_percent}%)</td>
									<td className="text-right font-weight-bold">
										<CurrencyValueFlex currencyObject={salesOrder?.converted_currency_vat_amount} defaultCurrency={salesOrder?.currency} flex={true} />
									</td>
								</tr>
							)}
							{salesOrder?.transit_fee && (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="d-md-none"></td>
									<td className="text-right">Transit Fee</td>
									<td className="text-right font-weight-bold">
										<CurrencyValueFlex currencyObject={salesOrder?.converted_currency_transit_fee} defaultCurrency={salesOrder?.currency} flex={true} />
									</td>
								</tr>
							)}
							{!salesOrder ? (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile text-right">
										<div className="w-full flex justify-content-end">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									</td>
									<td className="hide-on-mobile text-center">
										<div className="w-full flex justify-content-center">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									</td>
									<td className="d-md-none"></td>
									<td className="text-right">
										<div className="w-full flex justify-content-end">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									</td>
									<td className="text-right font-weight-bold">
										<div className="w-full flex justify-content-end">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									</td>
								</tr>
							) : (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile text-right">Total Qty</td>
									<td className="hide-on-mobile text-center">{totalQty}</td>
									{
										viewedBy === 'ADMIN' && (
											<>
												<td className="d-md-none"></td>
												<td className="text-right">Total</td>
												<td className="text-right font-weight-bold">
													<CurrencyValueFlex currencyObject={salesOrder?.converted_currency_total} defaultCurrency={salesOrder?.currency} flex={true} />
												</td>
											</>
										)
									}
								</tr>
							)}
							{
								viewedBy === 'ADMIN' && (
									salesOrder?.open_balance?.open > 0 && (
										isLoading ? (
											<tr>
												<td className="hide-on-mobile"></td>
												<td className="hide-on-mobile"></td>
												<td className="hide-on-mobile"></td>
												<td className="hide-on-mobile"></td>
												<td className="d-md-none"></td>
												<td className="text-right">
													<div className="w-full flex justify-content-end">
														<div style={{ width: '60px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
														</div>
													</div>
												</td>
												<td className="text-right font-weight-bold">
													<div className="w-full flex justify-content-end">
														<div style={{ width: '60px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
														</div>
													</div>
												</td>
											</tr>
										) : (
											<tr>
												<td className="hide-on-mobile"></td>
												<td className="hide-on-mobile"></td>
												<td className="hide-on-mobile"></td>
												<td className="d-md-none"></td>
												<td colSpan={2} className="text-right">Balance due</td>
												<td className="text-right font-weight-bold">
														
													<CurrencyValueFlex
														currencyObject={salesOrder?.converted_currency_open_balance}
														defaultCurrency={salesOrder?.currency}
														flex={true}
													/>
												</td>
											</tr>
										)
									)
								)
							}
						</tbody>
					</table>
				</div>
				<div className="show-on-mobile" style={{ width: '100%', marginTop: '20px' }}>
					<div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
						{salesOrder?.sales_order_items?.map((item) => (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									width: '100%',
									borderBottom: '1px solid #eee',
									padding: '8px 0'
								}}
							>
								<div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginRight: 12 }}>
									<div className="" style={{ fontWeight: 500 }}>
										{item?.product?.product_name} 
										{ item?.selectedColorName && ` ${item?.selectedColorName}` }
									</div>

									<div style={{ display: 'flex', gap: 10, alignItems: 'center', color: '#737373' }}>
										<div style={{}}>QTY - {item?.qty}</div>
										{
											viewedBy === 'ADMIN' && (
												<>
													<div>|</div>
													<div style={{ display: 'flex', gap: 4 }}>
														Price - <CurrencyValue currencyObject={item?.converted_currency_unit_price} defaultCurrency={salesOrder?.currency} />
													</div>
												</>
											)
										}
									</div>
									{
										viewedBy === 'ADMIN' && (
											<div style={{ fontWeight: 500 }}>
												<CurrencyValue currencyObject={item?.converted_currency_total_price} defaultCurrency={salesOrder?.currency} />
											</div>
										)
									}
								</div>
                                <div style={{ width: '11%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									{item?.product?.thumbnail_url ? (
										<img src={item?.product?.thumbnail_url} style={{ width: '65%', height: '65%', objectFit: 'cover' }} alt="product" />
									) : item?.product?.custom_thumbnail_url ? (
										<img
											src={item?.product?.custom_thumbnail_url}
											style={{ width: '65%', height: '65%', objectFit: 'cover' }}
											alt="product"
										/>
									) : (
										<NoPhoneIcon width={'41px'} height={'38px'} />	
									)}
								</div>
							</div>
						))}
						<div style={{display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: "center", paddingTop: 10}}>
							<div style={{fontWeight: 500}}>QTY {totalQty}</div>
							{
								viewedBy === 'ADMIN' && (
								<div style={{fontWeight: 500, minWidth: '100px', display: 'flex', gap: '10px', justifyContent: 'end'}}>
									Total{' '}
									<CurrencyValue currencyObject={salesOrder?.converted_currency_total} defaultCurrency={salesOrder?.currency} />
								</div>
								)
							}
						</div>
					</div>
				</div>
			</div>

			{productComment && (
				<ProductCommentModal
					name={productName}
					image={productImage}
					comment={productComment}
					// show={commentModal}
					handleClose={() => handleCloseComment()}
				/>
			)}
		</>
	);
}

export default SalesOrderDetailInvoice;
